import { getClientPublicGreeting, unlockClientCredentials } from './supabaseClient.js';
import { showToast } from './retroAlert.js';

document.addEventListener('DOMContentLoaded', async () => {
  // Contenedores de Estado
  const stateChallenge = document.getElementById('state-challenge');
  const stateUnlocked = document.getElementById('state-unlocked');
  const stateInvalid = document.getElementById('state-invalid');

  // Elementos de Desafío (2FA)
  const greetingClientName = document.getElementById('greeting-client-name');
  const challengeError = document.getElementById('challenge-error');
  const challengeForm = document.getElementById('challenge-form');
  const inputPhoneChallenge = document.getElementById('input-phone-challenge');
  const btnUnlockVault = document.getElementById('btn-unlock-vault');

  // Elementos de Bóveda Desbloqueada
  const unlockedClientName = document.getElementById('unlocked-client-name');
  const unlockedVencimiento = document.getElementById('unlocked-vencimiento');
  const vaultUserInput = document.getElementById('vault-user-input');
  const vaultPassInput = document.getElementById('vault-pass-input');
  const btnToggleVaultPass = document.getElementById('btn-toggle-vault-pass');
  const btnCopyUser = document.getElementById('btn-copy-user');
  const btnCopyPass = document.getElementById('btn-copy-pass');

  // Obtener ID del cliente de la URL
  const params = new URLSearchParams(window.location.search);
  const clientId = params.get('id');

  if (!clientId) {
    if (stateChallenge) stateChallenge.classList.add('hidden');
    if (stateInvalid) stateInvalid.classList.remove('hidden');
    return;
  }

  // Cargar saludo público básico para mostrar el nombre del titular
  try {
    const greeting = await getClientPublicGreeting(clientId);
    if (greeting && greeting.nombre_completo && greetingClientName) {
      greetingClientName.textContent = `¡HOLA, ${greeting.nombre_completo.toUpperCase()}! BIENVENIDO A TU BÓVEDA`;
    }
  } catch (err) {
    console.warn('Error al cargar saludo público de entrega:', err);
  }

  // Envío del formulario de validación (Desafío 2FA)
  if (challengeForm) {
    challengeForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!inputPhoneChallenge || !btnUnlockVault) return;

      const phoneVal = inputPhoneChallenge.value.trim();
      if (!phoneVal) return;

      btnUnlockVault.disabled = true;
      btnUnlockVault.innerHTML = '<span>⏳</span> <span>VERIFICANDO ENCRIPTACIÓN...</span>';
      if (challengeError) challengeError.classList.add('hidden');

      try {
        const credentials = await unlockClientCredentials(clientId, phoneVal);

        if (credentials && credentials.cuenta_asignada) {
          // Desbloqueo exitoso: cambiar estado
          if (stateChallenge) stateChallenge.classList.add('hidden');
          if (stateUnlocked) stateUnlocked.classList.remove('hidden');

          if (unlockedClientName) {
            unlockedClientName.textContent = credentials.nombre_completo 
              ? `CUENTA ASIGNADA A ${credentials.nombre_completo.toUpperCase()}`
              : 'CUENTA ASIGNADA ACTIVA';
          }

          if (vaultUserInput) {
            vaultUserInput.value = credentials.cuenta_asignada;
          }

          if (vaultPassInput) {
            vaultPassInput.value = credentials.password_cuenta || 'InstaPlay#2026!';
          }

          if (unlockedVencimiento) {
            unlockedVencimiento.textContent = credentials.fecha_vencimiento 
              ? `Hasta: ${credentials.fecha_vencimiento}` 
              : '30 días de suscripción activa';
          }

          // Especificaciones y Mejoras de Cuenta (Plus)
          const vaultSalsanowBadge = document.getElementById('vault-salsanow-badge');
          const vaultSalsanowDesc = document.getElementById('vault-salsanow-desc');
          const vaultStorageBadge = document.getElementById('vault-storage-badge');
          const vaultStorageDesc = document.getElementById('vault-storage-desc');
          const vaultHoursBadge = document.getElementById('vault-hours-badge');
          const vaultHoursDesc = document.getElementById('vault-hours-desc');
          const vaultSpecsTier = document.getElementById('vault-specs-tier');
          const vaultUpgradeCtaBox = document.getElementById('vault-upgrade-cta-box');

          const hasSalsa = Boolean(credentials.has_salsanow);
          const has1TB = credentials.storage_capacity === '1TB';
          const has150h = credentials.monthly_hours === 150;

          if (vaultSalsanowBadge) {
            if (hasSalsa) {
              vaultSalsanowBadge.textContent = 'ACTIVO ✓';
              vaultSalsanowBadge.className = 'px-1.5 py-0.5 text-[10px] font-bold border border-green-500 bg-green-950 text-green-300';
              if (vaultSalsanowDesc) vaultSalsanowDesc.textContent = 'Instalación configurada para jugar títulos no oficiales';
            } else {
              vaultSalsanowBadge.textContent = 'NO INSTALADO';
              vaultSalsanowBadge.className = 'px-1.5 py-0.5 text-[10px] font-bold border border-gray-600 bg-black text-gray-400';
              if (vaultSalsanowDesc) vaultSalsanowDesc.textContent = 'Catálogo estándar GFN. Disponible para activar por $2 USD';
            }
          }

          if (vaultStorageBadge) {
            if (has1TB) {
              vaultStorageBadge.textContent = '1 TB (1000 GB) ✓';
              vaultStorageBadge.className = 'px-1.5 py-0.5 text-[10px] font-bold border border-purple-500 bg-purple-950 text-purple-300';
              if (vaultStorageDesc) vaultStorageDesc.textContent = 'Almacenamiento expandido para juegos de SalsaNow';
            } else {
              vaultStorageBadge.textContent = '100 GB (ESTÁNDAR)';
              vaultStorageBadge.className = 'px-1.5 py-0.5 text-[10px] font-bold border border-gray-600 bg-black text-gray-400';
              if (vaultStorageDesc) vaultStorageDesc.textContent = 'Espacio base para SalsaNow. Ampliable a 1 TB por $4 USD';
            }
          }

          if (vaultHoursBadge) {
            if (has150h) {
              vaultHoursBadge.textContent = '150 HORAS VIP ✓';
              vaultHoursBadge.className = 'px-1.5 py-0.5 text-[10px] font-bold border border-yellow-500 bg-yellow-950 text-yellow-300';
              if (vaultHoursDesc) vaultHoursDesc.textContent = '50 horas extra añadidas a tu ciclo de juego mensual';
            } else {
              vaultHoursBadge.textContent = '100 HORAS / MES';
              vaultHoursBadge.className = 'px-1.5 py-0.5 text-[10px] font-bold border border-green-600 bg-green-950 text-green-300';
              if (vaultHoursDesc) vaultHoursDesc.textContent = 'Tiempo estándar mensual. Extensible a 150h por $5 USD';
            }
          }

          if (vaultSpecsTier) {
            if (hasSalsa && has1TB && has150h) {
              vaultSpecsTier.textContent = '👑 PERFIL ALL-ACCESS VIP';
              vaultSpecsTier.className = 'text-xs px-2.5 py-0.5 bg-yellow-950 border border-yellow-400 text-yellow-300 font-bold';
            } else if (hasSalsa || has1TB || has150h) {
              vaultSpecsTier.textContent = '⚡ PERFIL MEJORADO (PLUS)';
              vaultSpecsTier.className = 'text-xs px-2.5 py-0.5 bg-cyan-950 border border-cyan-400 text-cyan-300 font-bold';
            } else {
              vaultSpecsTier.textContent = '🎮 PERFIL ESTÁNDAR';
              vaultSpecsTier.className = 'text-xs px-2.5 py-0.5 bg-[#011e0c] border border-[#00ff41] text-[#00ff41] font-bold';
            }
          }

          // Sistema de Referidos en Bóveda
          const vaultReferralCode = document.getElementById('vault-referral-code');
          const vaultReferralsCount = document.getElementById('vault-referrals-count');
          const btnCopyRefLink = document.getElementById('btn-copy-ref-link');

          const refCode = credentials.referral_code || ('PLAY-' + (credentials.id ? credentials.id.substring(0, 6) : 'VIP').toUpperCase());
          if (vaultReferralCode) {
            vaultReferralCode.textContent = refCode;
          }
          if (vaultReferralsCount) {
            const count = credentials.referrals_count || 0;
            vaultReferralsCount.textContent = `${count} Referido${count === 1 ? '' : 's'}`;
          }

          if (btnCopyRefLink) {
            btnCopyRefLink.onclick = async () => {
              const inviteText = `🎮 ¡Hola! Estoy jugando en PC y celular a través de InstaPlay Latam sin descargas y sin lag. Usa mi código de invitado *${refCode}* al solicitar tu mes de juego para desbloquear beneficios: https://instaplaylatam.com?ref=${refCode}`;
              try {
                await navigator.clipboard.writeText(inviteText);
                showToast('¡Enlace y código de referido copiado al portapapeles!', 'success');
              } catch {
                showToast(`Tu código es: ${refCode}`, 'info');
              }
            };
          }

          showToast('¡Bóveda desbloqueada! Tus credenciales están listas.', 'success');
        } else {
          // Teléfono incorrecto
          if (challengeError) challengeError.classList.remove('hidden');
          inputPhoneChallenge.focus();
        }
      } catch (err) {
        console.error('Fallo al validar credenciales:', err);
        if (challengeError) challengeError.classList.remove('hidden');
      } finally {
        btnUnlockVault.disabled = false;
        btnUnlockVault.innerHTML = '<span>🔓</span> <span>DESBLOQUEAR MIS CREDENCIALES</span>';
      }
    });
  }

  // Alternar visualización de contraseña
  if (btnToggleVaultPass && vaultPassInput) {
    btnToggleVaultPass.addEventListener('click', () => {
      const isPassword = vaultPassInput.type === 'password';
      vaultPassInput.type = isPassword ? 'text' : 'password';
      btnToggleVaultPass.textContent = isPassword ? '[ 🙈 OCULTAR ]' : '[ 👁️ VER CONTRASEÑA ]';
    });
  }

  // Copiar usuario al portapapeles
  if (btnCopyUser && vaultUserInput) {
    btnCopyUser.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(vaultUserInput.value);
        showToast('Usuario/Correo copiado al portapapeles', 'success');
      } catch {
        vaultUserInput.select();
        document.execCommand('copy');
        showToast('Usuario copiado', 'success');
      }
    });
  }

  // Copiar contraseña al portapapeles
  if (btnCopyPass && vaultPassInput) {
    btnCopyPass.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(vaultPassInput.value);
        showToast('Contraseña copiada al portapapeles', 'success');
      } catch {
        vaultPassInput.select();
        document.execCommand('copy');
        showToast('Contraseña copiada', 'success');
      }
    });
  }
});
